<template>
  <span class="ai-visibility-trend-badge" :class="`ai-visibility-trend-badge--${resolvedTone}`">
    <i class="material-icons">{{ iconName }}</i>
    <span>{{ label }}</span>
  </span>
</template>

<script>
export default {
  name: 'TrendBadge',
  props: {
    direction: {
      type: String,
      default: 'up',
    },
    tone: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconName () {
      if (this.direction === 'down') {
        return 'arrow_downward'
      }
      if (this.direction === 'flat') {
        return ''
      }
      return 'arrow_upward'
    },
    resolvedTone () {
      if (['positive', 'negative', 'neutral'].indexOf(this.tone) > -1) {
        return this.tone
      }
      if (this.direction === 'down') {
        return 'negative'
      }
      if (this.direction === 'flat') {
        return 'neutral'
      }
      return 'positive'
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-trend-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.3;
  padding: 6px 10px 6px 8px;
  width: fit-content;

  span {
    font-size: 16px;
  }
}

.ai-visibility-trend-badge i {
  font-size: 14px;
}

.ai-visibility-trend-badge--positive {
  background: var(--v-green10Color-base);
  color: var(--v-green8Color-base);
}

.ai-visibility-trend-badge--negative {
  background: var(--v-red6Color-base);
  color: var(--v-red11Color-base);
}

.ai-visibility-trend-badge--neutral {
  background: var(--v-gray10Color-base);
  color: var(--v-gray50Color-base);
}
</style>
